"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BHGErrorMessage = void 0;

var _react = _interopRequireDefault(require("react"));

require("./ErrorMessage.scss");

var BHGErrorMessage = function BHGErrorMessage(props) {
  var message = props.message,
      className = props.className;
  return message ? /*#__PURE__*/_react.default.createElement("div", {
    className: "bhg-error-message " + (className ? className : "")
  }, message) : null;
};

exports.BHGErrorMessage = BHGErrorMessage;
BHGErrorMessage.defaultProps = {
  message: null,
  className: null
};